import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPropertyType } from "reduxStore/action/masterActions";
import {
  getAllProperty,
  getPropertyFilterList,
  propertyGreMobileOtpUpdate,
  propertyGreBannerUpdate,
  propertyGreBannerRemove,
  getAgentProperty,
} from "reduxStore/action/propertyActions";
import TableDataNotFound from "component/TableDataNotFound";
import strings from "translate/language";
import { handleListResponse, seo, normalizeMongoId } from "utils/utils";
import { AdminRoleId } from "utils/constants";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import Select from "react-select";
// import { syncAllProjects } from "../../reduxStore/action/propertyActions";
import { handleDetailResponse } from "utils/utils";
import { errorToast } from "utils/httpClient";
import propertyService from "reduxStore/service/propertyService";
import {
  GRE_BANNER_ALLOWED_MIME_TYPES,
  validateGreBannerFile,
} from "utils/greBannerUpload";
import "./PropertyListing.css";

const Property = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [apiResponse, setApiResponse] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const propertySelector = useSelector((state) => state.propertyData) || {};
  const ReportListSelector = useSelector((state) => state.report);
  const { create, view, edit, isAdmin } = usePermission({
    create: "add_property",
    view: "view_property",
    edit: "edit_property",
  });

  const user_id = useSelector((state) => {
    const { response } = state.login;
    return handleDetailResponse(response.data)._id;
  });

  const role_id = useSelector((state) => {
    const { response } = state.login;
    return handleDetailResponse(response.data).role_id;
  });

  const isSuperAdmin = String(role_id || "") === String(AdminRoleId);

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    location: "",
    property_name: "",
    property_type: "",
    gre_mobile_otp: "",
  });

  const [searchData, setSearchData] = useState([]);
  const [propertyMediaBaseUrl, setPropertyMediaBaseUrl] = useState("");
  // Modal preview state for super admin GRE banner column.
  const [bannerPreview, setBannerPreview] = useState({
    open: false,
    url: "",
    title: "",
    objectUrl: "",
  });
  const [bannerRemoveConfirm, setBannerRemoveConfirm] = useState({
    open: false,
    propertyId: null,
    propertyTitle: "",
    removing: false,
  });
  const [bannerUploadModal, setBannerUploadModal] = useState({
    open: false,
    propertyId: null,
    propertyTitle: "",
    hasExistingBanner: false,
    selectedFile: null,
    previewUrl: "",
    error: "",
    uploading: false,
  });
  const greBannerFileInputRef = useRef(null);

  const closeBannerPreview = () => {
    setBannerPreview((current) => {
      if (current.objectUrl) {
        URL.revokeObjectURL(current.objectUrl);
      }
      return { open: false, url: "", title: "", objectUrl: "" };
    });
  };

  // Opens preview modal by loading banner blob from getGreBannerImage API.
  const handleGreBannerPreview = async (item) => {
    const propertyId = normalizeMongoId(item?._id ?? item?.property_id);
    if (!propertyId) {
      return;
    }

    try {
      const response = await propertyService.getGreBannerImageBlob({
        property_id: propertyId,
      });
      if (response?.noBanner || !response?.data) {
        errorToast(strings.greBannerUpdateFailedTitle);
        return;
      }
      const objectUrl = URL.createObjectURL(response.data);
      setBannerPreview((current) => {
        if (current.objectUrl) {
          URL.revokeObjectURL(current.objectUrl);
        }
        return {
          open: true,
          url: objectUrl,
          title: item.property_title,
          objectUrl,
        };
      });
    } catch (error) {
      errorToast(strings.greBannerUpdateFailedTitle);
    }
  };

  const { response } = propertySelector;

  const propertyTypesSelector = useSelector((state) => state.propertyTypes);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    if (isAdmin) {
      const { reportPropertyList } = ReportListSelector;
      if (reportPropertyList) {
        if (reportPropertyList?.status === 200) {
          setPropertyList(handleListResponse(reportPropertyList.data));
        } else {
          setPropertyList([]);
        }
      }
    }
  }, [ReportListSelector]);

  useEffect(() => {
    if (propertyTypesSelector?.response) {
      const { response } = propertyTypesSelector;
      if (response?.status === 200) {
        setSearchData(response.data);
      } else {
        setSearchData([]);
      }
    }
  }, [propertyTypesSelector]);

  useEffect(() => {
    dispatch(getPropertyType());
    if (isAdmin) {
      dispatch(getAllProperty({ offset: page, limit: 10 }));
    } else {
      dispatch(getAgentProperty({ offset: page, limit: 10 }));
    }
  }, [dispatch]);

  const buildListParams = (offset = page) => ({
    limit: 10,
    offset,
    start_date: form.start_date,
    end_date: form.end_date,
    location: form.location,
    property_name: form?.site?.property_title,
    property_type: form.property_type,
    gre_mobile_otp: form.gre_mobile_otp,
  });

  const refreshPropertyList = (offset = page) => {
    const params = buildListParams(offset);
    if (isAdmin) {
      dispatch(getAllProperty(params));
    } else {
      dispatch(getAgentProperty(params));
    }
  };

  const matchesPropertyId = (item, propertyId) =>
    String(item?._id || "") === String(propertyId || "") ||
    String(item?.property_id || "") === String(propertyId || "");

  const applyClientFilters = (list) => {
    if (!Array.isArray(list)) {
      return [];
    }

    let result = list;

    if (form.property_type === "1") {
      result = result.filter((item) => item.status === true);
    } else if (form.property_type === "2") {
      result = result.filter((item) => item.status === false);
    }

    if (form.gre_mobile_otp === "1") {
      result = result.filter((item) => Boolean(item.gre_mobile_otp_enabled));
    } else if (form.gre_mobile_otp === "2") {
      result = result.filter((item) => !item.gre_mobile_otp_enabled);
    }

    return result;
  };

  useEffect(() => {
    if (propertySelector.create) {
      return;
    }

    if (response && response.status === 200) {
      const list = handleListResponse(response?.data);
      setApiResponse(applyClientFilters(list));
      setPropertyList(list);
      if (response?.property_media_base_url) {
        setPropertyMediaBaseUrl(response.property_media_base_url);
      }
    } else if (response) {
      setApiResponse([]);
    }
  }, [dispatch, propertySelector, form.property_type, form.gre_mobile_otp]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(getPropertyFilterList(buildListParams(0)));
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      location: "",
      property_name: "",
      property_type: "",
      gre_mobile_otp: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    if (isAdmin) {
      dispatch(getAllProperty(buildListParams(0)));
    } else {
      dispatch(getAgentProperty(buildListParams(0)));
    }

    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const applyOtpChangeToList = (propertyId, enabled) => {
    const otpFilter = form.gre_mobile_otp;
    const removedByFilter =
      (otpFilter === "1" && !enabled) ||
      (otpFilter === "2" && enabled);

    setApiResponse((prev) => {
      if (removedByFilter) {
        return prev.filter((item) => !matchesPropertyId(item, propertyId));
      }
      return prev.map((item) =>
        matchesPropertyId(item, propertyId)
          ? { ...item, gre_mobile_otp_enabled: enabled }
          : item,
      );
    });
  };

  const handleGreMobileOtpToggle = async (propertyId, enabled, propertyTitle) => {
    const previous = apiResponse;
    applyOtpChangeToList(propertyId, enabled);

    const success = await dispatch(
      propertyGreMobileOtpUpdate({
        property_id: propertyId,
        gre_mobile_otp_enabled: enabled,
        property_title: propertyTitle,
      }),
    );

    if (!success) {
      setApiResponse(previous);
      return;
    }

    refreshPropertyList(page);
  };

  // Uploads/replaces GRE banner for a property via multipart FormData.
  const handleGreBannerUpload = async (propertyId, file) => {
    if (!file) {
      return false;
    }

    const normalizedPropertyId = normalizeMongoId(propertyId);
    if (!normalizedPropertyId) {
      errorToast(strings.greBannerUpdateFailedTitle);
      return false;
    }

    const formData = new FormData();
    formData.append("property_id", normalizedPropertyId);
    formData.append("gre_banner", file);

    const result = await dispatch(propertyGreBannerUpdate(formData));
    if (!result) {
      return false;
    }

    if (result.property_media_base_url) {
      setPropertyMediaBaseUrl(result.property_media_base_url);
    }

    setApiResponse((prev) =>
      prev.map((item) =>
        matchesPropertyId(item, propertyId)
          ? {
              ...item,
              gre_banner: result.gre_banner,
              gre_banner_url: result.gre_banner_url,
              gre_banner_cache: Date.now(),
            }
          : item,
      ),
    );

    return true;
  };

  const revokeBannerUploadPreview = (previewUrl) => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
  };

  const closeBannerUploadModal = () => {
    setBannerUploadModal((current) => {
      if (current.uploading) {
        return current;
      }

      revokeBannerUploadPreview(current.previewUrl);
      if (greBannerFileInputRef.current) {
        greBannerFileInputRef.current.value = "";
      }

      return {
        open: false,
        propertyId: null,
        propertyTitle: "",
        hasExistingBanner: false,
        selectedFile: null,
        previewUrl: "",
        error: "",
        uploading: false,
      };
    });
  };

  const openBannerUploadModal = (item) => {
    const propertyId = normalizeMongoId(item?._id ?? item?.property_id);
    if (!propertyId) {
      return;
    }

    setBannerUploadModal((current) => {
      revokeBannerUploadPreview(current.previewUrl);
      if (greBannerFileInputRef.current) {
        greBannerFileInputRef.current.value = "";
      }

      return {
        open: true,
        propertyId,
        propertyTitle: item?.property_title || "",
        hasExistingBanner: Boolean(item?.gre_banner),
        selectedFile: null,
        previewUrl: "",
        error: "",
        uploading: false,
      };
    });
  };

  const clearBannerUploadSelection = () => {
    setBannerUploadModal((current) => {
      if (current.uploading) {
        return current;
      }

      revokeBannerUploadPreview(current.previewUrl);
      if (greBannerFileInputRef.current) {
        greBannerFileInputRef.current.value = "";
      }

      return {
        ...current,
        selectedFile: null,
        previewUrl: "",
        error: "",
      };
    });
  };

  const handleGreBannerFileSelection = (file) => {
    const validation = validateGreBannerFile(file, {
      invalidFormat: strings.greBannerInvalidFormat,
      fileTooLarge: strings.greBannerFileTooLarge,
    });

    setBannerUploadModal((current) => {
      revokeBannerUploadPreview(current.previewUrl);

      if (!validation.valid) {
        if (greBannerFileInputRef.current) {
          greBannerFileInputRef.current.value = "";
        }

        return {
          ...current,
          selectedFile: null,
          previewUrl: "",
          error: validation.error,
        };
      }

      const previewUrl = URL.createObjectURL(file);
      return {
        ...current,
        selectedFile: file,
        previewUrl,
        error: "",
      };
    });
  };

  const confirmGreBannerUpload = async () => {
    const { propertyId, selectedFile } = bannerUploadModal;
    if (!propertyId || !selectedFile) {
      return;
    }

    const validation = validateGreBannerFile(selectedFile, {
      invalidFormat: strings.greBannerInvalidFormat,
      fileTooLarge: strings.greBannerFileTooLarge,
    });

    if (!validation.valid) {
      setBannerUploadModal((current) => ({
        ...current,
        error: validation.error,
      }));
      return;
    }

    setBannerUploadModal((current) => ({ ...current, uploading: true, error: "" }));

    const success = await handleGreBannerUpload(propertyId, selectedFile);

    if (!success) {
      setBannerUploadModal((current) => ({ ...current, uploading: false }));
      return;
    }

    setBannerUploadModal((current) => {
      revokeBannerUploadPreview(current.previewUrl);
      if (greBannerFileInputRef.current) {
        greBannerFileInputRef.current.value = "";
      }

      return {
        open: false,
        propertyId: null,
        propertyTitle: "",
        hasExistingBanner: false,
        selectedFile: null,
        previewUrl: "",
        error: "",
        uploading: false,
      };
    });
  };

  // Opens confirm modal before GRE banner is removed from S3 and the database.
  const openBannerRemoveConfirm = (item) => {
    const propertyId = normalizeMongoId(item?._id ?? item?.property_id);
    if (!propertyId) {
      return;
    }

    setBannerRemoveConfirm({
      open: true,
      propertyId,
      propertyTitle: item?.property_title || "",
      removing: false,
    });
  };

  const closeBannerRemoveConfirm = () => {
    setBannerRemoveConfirm((current) => {
      if (current.removing) {
        return current;
      }

      return {
        open: false,
        propertyId: null,
        propertyTitle: "",
        removing: false,
      };
    });
  };

  // Optimistic UI clear; rolls back if propertyGreBannerRemove API fails.
  const confirmGreBannerRemove = async () => {
    const propertyId = bannerRemoveConfirm.propertyId;
    if (!propertyId) {
      return;
    }

    setBannerRemoveConfirm((current) => ({ ...current, removing: true }));

    const previous = apiResponse;
    setApiResponse((prev) =>
      prev.map((item) =>
        matchesPropertyId(item, propertyId)
          ? { ...item, gre_banner: null, gre_banner_url: null, gre_banner_cache: null }
          : item,
      ),
    );

    const success = await dispatch(
      propertyGreBannerRemove({ property_id: propertyId }),
    );

    if (!success) {
      setApiResponse(previous);
      setBannerRemoveConfirm((current) => ({ ...current, removing: false }));
      return;
    }

    setBannerRemoveConfirm({
      open: false,
      propertyId: null,
      propertyTitle: "",
      removing: false,
    });
  };

  useEffect(() => {
    if (isAdmin) {
      dispatch(
        getReportPropertyList({ limit: 10, offset: 0, user_id, role_id }),
      );
    }
  }, [dispatch]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    refreshPropertyList(newOffset);
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Property Listing",
      metaDescription: "All registered property list",
      canonicalLink: window.location.href,
    });
  }, []);
  const formatPropertyModalMessage = (template, propertyTitle) => {
    const property = String(propertyTitle || "").trim() || "This property";
    return String(template || "").replace(/\{\{property\}\}/g, property);
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.Property}
        titleactive={strings.propertyListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card property-listing-filters-card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              // data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchBylocality}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              placeholder={strings.searchlocality}
                              type="text"
                              autoComplete="off"
                              name="location"
                              value={form.location}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4  ">
                          <span className="cardText">
                            {strings.searchByProjectName}
                          </span>
                          <Select
                            className="property-listing-filter-select"
                            classNamePrefix="property-listing-select"
                            isSearchable
                            isClearable
                            menuPortalTarget={
                              typeof document !== "undefined"
                                ? document.body
                                : null
                            }
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            onInputChange={(e) => {
                              if (isAdmin) {
                                // Use getAgentProperty if isAdmin is true
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    }),
                                  );
                                }
                              } else {
                                // Default behavior: use getReportPropertyList

                                if (e.length > 1) {
                                  dispatch(
                                    getAgentProperty({
                                      search_site: e,
                                      isLoadMore: true,
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    getAgentProperty({
                                      limit: "",
                                      offset: 0,
                                      isLoadMore: true,
                                    }),
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByProjectName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="property_type"
                            value={form.property_type}
                            onChange={(event) => handleInputField(event)}
                          >
                            <option defaultValue={null}>
                              {strings.selectstatus}
                            </option>
                            <option value={"1"}>{strings.active}</option>
                            <option value={"2"}>{strings.deactive}</option>
                          </select>
                        </div>
                        {isSuperAdmin && (
                          <div className="col-md-4">
                            <span className="cardText">
                              {strings.searchByOtpVerification}
                            </span>
                            <select
                              className="form-control digits"
                              name="gre_mobile_otp"
                              value={form.gre_mobile_otp}
                              onChange={(event) => handleInputField(event)}
                            >
                              <option value="">{strings.selectOtpVerification}</option>
                              <option value="1">{strings.greMobileOtpEnabled}</option>
                              <option value="2">{strings.greMobileOtpDisabled}</option>
                            </select>
                          </div>
                        )}
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-12 d-flex justify-content-end">
                          <div className="form-group mb-0">
                            <Button
                              className="btn btn-warning  mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            ></Button>
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    {/* <Button
                      onClick={() => navigatpage("/addnewproperty")}
                      label={strings.addNewProperty}
                    ></Button> */}
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <div className="form-group" style={{ float: "right" }}>
                    <Button
                      label={strings.syncAllProperty}
                      onClick={() => {
                        dispatch(syncAllProjects());
                      }}
                    ></Button>
                  </div>
                </div> */}
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card property-listing-card">
                  <div className="card-header">
                    <h5>{strings.propertyList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table property-listing-table">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="property-listing-table__project-col"
                          >
                            {strings.projectName}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__date-col"
                          >
                            {strings.createdDate}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__metric-col"
                          >
                            {strings.vistior}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__metric-col"
                          >
                            {strings.sitevisit}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__metric-col"
                          >
                            {strings.bookingVisit}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__metric-col"
                          >
                            {strings.closeVisit}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__status-col"
                          >
                            {strings.status}
                          </th>
                          {isSuperAdmin && (
                            <th
                              scope="col"
                              className="property-listing-table__otp-col"
                            >
                              <span className="property-listing-table__otp-title">
                                {strings.greMobileOtpTitle}
                              </span>
                              <span className="property-listing-table__otp-hint">
                                {strings.greMobileOtpHint}
                              </span>
                            </th>
                          )}
                          {isSuperAdmin && (
                            <th
                              scope="col"
                              className="property-listing-table__banner-col"
                            >
                              <span className="property-listing-table__otp-title">
                                {strings.greBannerTitle}
                              </span>
                              <span className="property-listing-table__otp-hint">
                                {strings.greBannerHint}
                              </span>
                            </th>
                          )}
                          <th
                            scope="col"
                            className="property-listing-table__budget-col"
                          >
                            {strings.budget}
                          </th>
                          <th
                            scope="col"
                            className="property-listing-table__actions-col"
                          >
                            {strings.action}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {apiResponse &&
                          apiResponse.map((item, index) => {
                            const isOtpEnabled = Boolean(
                              item.gre_mobile_otp_enabled,
                            );
                            const hasBudget =
                              item?.min_rate || item?.max_rate;

                            return (
                              <tr key={index}>
                                <td className="property-listing-table__project property-listing-table__project-col">
                                  <span
                                    className="property-listing-table__project-name"
                                    title={item.property_title}
                                  >
                                    {item.property_title}
                                  </span>
                                </td>
                                <td className="property-listing-table__date property-listing-table__date-col">
                                  {moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a",
                                  )}
                                </td>
                                <td className="property-listing-table__metric property-listing-table__metric-col">
                                  {item.total_visitor}
                                </td>
                                <td className="property-listing-table__metric property-listing-table__metric-col">
                                  {item.site_visit}
                                </td>
                                <td className="property-listing-table__metric property-listing-table__metric-col">
                                  {item.booking_visit}
                                </td>
                                <td className="property-listing-table__metric property-listing-table__metric-col">
                                  {item.close_visit}
                                </td>
                                <td className="property-listing-table__status-col">
                                  <span
                                    className={`property-status-badge ${
                                      item.status
                                        ? "property-status-badge--active"
                                        : "property-status-badge--inactive"
                                    }`}
                                  >
                                    <span
                                      className="property-status-badge__dot"
                                      aria-hidden="true"
                                    />
                                    {item.status
                                      ? strings.active
                                      : strings.deactive}
                                  </span>
                                </td>
                                {isSuperAdmin && (
                                  <td className="property-listing-table__otp-col">
                                    <label
                                      className="property-otp-toggle"
                                      title={
                                        isOtpEnabled
                                          ? strings.greMobileOtpEnabled
                                          : strings.greMobileOtpDisabled
                                      }
                                    >
                                      <input
                                        className="property-otp-toggle__input"
                                        type="checkbox"
                                        checked={isOtpEnabled}
                                      onChange={(e) =>
                                        handleGreMobileOtpToggle(
                                          item._id,
                                          e.target.checked,
                                          item.property_title,
                                        )
                                      }
                                      />
                                      <span className="property-otp-toggle__track">
                                        <span className="property-otp-toggle__thumb" />
                                      </span>
                                      <span className="property-otp-toggle__label">
                                        {isOtpEnabled
                                          ? strings.greMobileOtpOn
                                          : strings.greMobileOtpOff}
                                      </span>
                                    </label>
                                  </td>
                                )}
                                {isSuperAdmin && (
                                  <td className="property-listing-table__banner-col">
                                    <div className="property-banner-upload">
                                      <div
                                        className={`property-banner-upload__actions${
                                          item.gre_banner
                                            ? ""
                                            : " property-banner-upload__actions--single"
                                        }`}
                                      >
                                        {item.gre_banner ? (
                                          <button
                                            type="button"
                                            className="property-banner-upload__preview"
                                            onClick={() =>
                                              handleGreBannerPreview(item)
                                            }
                                          >
                                            {strings.greBannerPreview}
                                          </button>
                                        ) : null}
                                        <button
                                          type="button"
                                          className="property-banner-upload__btn"
                                          onClick={() =>
                                            openBannerUploadModal(item)
                                          }
                                        >
                                          {item.gre_banner
                                            ? strings.greBannerReplace
                                            : strings.greBannerUpload}
                                        </button>
                                        {item.gre_banner ? (
                                          <button
                                            type="button"
                                            className="property-banner-upload__remove"
                                            onClick={() =>
                                              openBannerRemoveConfirm(item)
                                            }
                                          >
                                            {strings.greBannerRemove}
                                          </button>
                                        ) : null}
                                      </div>
                                    </div>
                                  </td>
                                )}
                                <td
                                  className={`property-listing-table__budget property-listing-table__budget-col${
                                    hasBudget
                                      ? ""
                                      : " property-listing-table__budget--empty"
                                  }`}
                                >
                                  {hasBudget ? (
                                    <>
                                      {item?.min_rate}
                                      {item.min_rate
                                        ? item.min_rate_type
                                        : null}
                                      {" - "}
                                      {item?.max_rate}
                                      {item.max_rate
                                        ? item.max_rate_type
                                        : null}
                                    </>
                                  ) : (
                                    "—"
                                  )}
                                </td>
                                <td className="property-listing-table__actions-col">
                                  <div className="property-listing-table__actions">
                                    {view && (
                                      <button
                                        type="button"
                                        className="property-action-btn"
                                        title={strings.viewProperty}
                                        onClick={() => {
                                          navigatpage(
                                            "/viewproperty/" + item._id,
                                          );
                                        }}
                                      >
                                        <i
                                          className="fa fa-eye"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    )}

                                    {edit &&
                                      (item?.status !== false ? (
                                        <button
                                          type="button"
                                          className="property-action-btn"
                                          title={strings.editProperty}
                                          onClick={() => {
                                            navigatpage(
                                              "/editproperty/" + item._id,
                                            );
                                          }}
                                        >
                                          <i
                                            className="fa fa-edit"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      ) : (
                                        <span
                                          className="property-action-btn property-action-btn--placeholder"
                                          aria-hidden="true"
                                        />
                                      ))}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <TableDataNotFound data={apiResponse} />
                  </div>
                  <Pagination
                    totalCount={propertySelector?.response?.total_data}
                    listData={apiResponse}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {bannerPreview.open ? (
        <div
          className="property-banner-preview-modal"
          role="dialog"
          aria-modal="true"
          aria-label={strings.greBannerPreview}
          onClick={closeBannerPreview}
        >
          <div
            className="property-banner-preview-modal__dialog"
            onClick={(e) => e.stopPropagation()}
          >
            {bannerPreview.title ? (
              <div className="property-banner-preview-modal__title">
                {bannerPreview.title}
              </div>
            ) : null}
            {bannerPreview.url ? (
              <img
                src={bannerPreview.url}
                alt={`${bannerPreview.title || "Property"} GRE banner`}
                className="property-banner-preview-modal__image"
              />
            ) : null}
            <button
              type="button"
              className="property-banner-preview-modal__close"
              onClick={closeBannerPreview}
            >
              Close
            </button>
          </div>
        </div>
      ) : null}
      {bannerUploadModal.open ? (
        <div
          className="property-banner-upload-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="greBannerUploadModalTitle"
          onClick={closeBannerUploadModal}
        >
          <div
            className="property-banner-upload-modal__dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="property-banner-upload-modal__header">
              <h5
                className="property-banner-upload-modal__title"
                id="greBannerUploadModalTitle"
              >
                {bannerUploadModal.hasExistingBanner
                  ? strings.greBannerUploadModalReplaceTitle
                  : strings.greBannerUploadModalTitle}
              </h5>
              <button
                type="button"
                className="property-banner-upload-modal__close"
                aria-label={strings.cancel}
                onClick={closeBannerUploadModal}
                disabled={bannerUploadModal.uploading}
              >
                ×
              </button>
            </div>
            <div className="property-banner-upload-modal__body">
              {bannerUploadModal.propertyTitle ? (
                <p className="property-banner-upload-modal__property-name">
                  {bannerUploadModal.propertyTitle}
                </p>
              ) : null}
              <ul className="property-banner-upload-modal__guidelines">
                <li>{strings.greBannerUploadRecommendedSize}</li>
                <li>{strings.greBannerUploadFormats}</li>
                <li>{strings.greBannerUploadMaxSize}</li>
              </ul>
              <input
                ref={greBannerFileInputRef}
                type="file"
                accept={GRE_BANNER_ALLOWED_MIME_TYPES.join(",")}
                className="property-banner-upload-modal__input"
                id="gre-banner-upload-input"
                disabled={bannerUploadModal.uploading}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    handleGreBannerFileSelection(file);
                  }
                }}
              />
              {bannerUploadModal.previewUrl ? (
                <div className="property-banner-upload-modal__preview-wrap">
                  <div className="property-banner-upload-modal__dropzone property-banner-upload-modal__dropzone--has-preview property-banner-upload-modal__dropzone--preview-only">
                    <img
                      src={bannerUploadModal.previewUrl}
                      alt={`${bannerUploadModal.propertyTitle || "Property"} GRE banner preview`}
                      className="property-banner-upload-modal__preview"
                    />
                  </div>
                  <button
                    type="button"
                    className="property-banner-upload-modal__clear-btn"
                    onClick={clearBannerUploadSelection}
                    disabled={bannerUploadModal.uploading}
                  >
                    {strings.greBannerUploadClearSelection}
                  </button>
                </div>
              ) : (
                <label
                  htmlFor="gre-banner-upload-input"
                  className="property-banner-upload-modal__dropzone"
                >
                  <span className="property-banner-upload-modal__dropzone-title">
                    {strings.greBannerUploadSelectFile}
                  </span>
                  <span className="property-banner-upload-modal__dropzone-hint">
                    {strings.greBannerUploadSelectFileHint}
                  </span>
                </label>
              )}
              {bannerUploadModal.error ? (
                <p
                  className="property-banner-upload-modal__error"
                  role="alert"
                >
                  {bannerUploadModal.error}
                </p>
              ) : null}
            </div>
            <div className="property-banner-upload-modal__footer">
              <button
                type="button"
                className="property-banner-upload-modal__btn property-banner-upload-modal__btn--cancel"
                onClick={closeBannerUploadModal}
                disabled={bannerUploadModal.uploading}
              >
                {strings.cancel}
              </button>
              <button
                type="button"
                className="property-banner-upload-modal__btn property-banner-upload-modal__btn--confirm"
                onClick={confirmGreBannerUpload}
                disabled={
                  bannerUploadModal.uploading || !bannerUploadModal.selectedFile
                }
              >
                {strings.greBannerUploadSubmit}
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {bannerRemoveConfirm.open ? (
        <div
          className="property-banner-remove-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="greBannerRemoveModalTitle"
          onClick={closeBannerRemoveConfirm}
        >
          <div
            className="property-banner-remove-modal__dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="property-banner-remove-modal__header">
              <h5
                className="property-banner-remove-modal__title"
                id="greBannerRemoveModalTitle"
              >
                {strings.greBannerRemoveTitle}
              </h5>
              <button
                type="button"
                className="property-banner-remove-modal__close"
                aria-label={strings.cancel}
                onClick={closeBannerRemoveConfirm}
                disabled={bannerRemoveConfirm.removing}
              >
                ×
              </button>
            </div>
            <div className="property-banner-remove-modal__body">
              {bannerRemoveConfirm.propertyTitle ? (
                <p className="property-banner-remove-modal__property-name">
                  {bannerRemoveConfirm.propertyTitle}
                </p>
              ) : null}
              <p className="property-banner-remove-modal__message">
                {formatPropertyModalMessage(
                  strings.greBannerRemoveMessage,
                  bannerRemoveConfirm.propertyTitle,
                )}
              </p>
            </div>
            <div className="property-banner-remove-modal__footer">
              <button
                type="button"
                className="property-banner-remove-modal__btn property-banner-remove-modal__btn--cancel"
                onClick={closeBannerRemoveConfirm}
                disabled={bannerRemoveConfirm.removing}
              >
                {strings.cancel}
              </button>
              <button
                type="button"
                className="property-banner-remove-modal__btn property-banner-remove-modal__btn--confirm"
                onClick={confirmGreBannerRemove}
                disabled={bannerRemoveConfirm.removing}
              >
                {strings.greBannerRemoveConfirm}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default Property;
